<template>
  <div v-if="input">
    <GameSettingTitle :input="value" @handleSaveDraft="handleSaveDraft" />
    <GameSettingTab :value="view" :input="value" @handleChangeView="handleChangeView" />
    <div class="z-border-red pa-2 pt-4">
      <div class="title">General Information</div>
      <v-divider class="my-3" />
      <v-layout wrap>
        <v-flex xs12 sm6 class="px-1">
          <div class="caption mb-2">Campaign Name *</div>
          <v-text-field
            v-model="input.name"
            v-validate="'required'"
            outline
            class="default-input"
            placeholder="Campaign Name"
            single-line
            name="campaignname"
            data-vv-as="Campaign Name"
            :error="errors.has('campaignname')"
            :error-messages="errors.has('campaignname') ? errors.first('campaignname') : ''"
          />
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex xs12 sm6 class="px-1">
          <div class="caption mb-2">Description</div>
          <VueEditor
            v-model="input.description"
            name="descriptionInput"
            :data-vv-as="$t('Description')"
            :placeholder="$t('Description')"
            :editor-toolbar="customToolbar"
          />
        </v-flex>
        <v-flex xs12 sm6 class="px-1">
          <div class="caption mb-2">Term & Condition</div>
          <VueEditor
            v-model="input.term_condition"
            name="termAndConditionInput"
            :data-vv-as="$t('Term & Condition')"
            :placeholder="$t('Term & Condition')"
            :editor-toolbar="customToolbar"
          />
        </v-flex>
      </v-layout>

      <div class="caption mb-2">Game Type *</div>
      <v-radio-group
        v-model="input.game_type"
        v-validate="'required'"
        :mandatory="false"
        row
        :disabled="input.is_draft == false"
        name="game_type"
        data-vv-as="Game Type"
        :error="errors.has('game_type')"
        :error-messages="errors.has('game_type') ? errors.first('game_type') : ''"
      >
        <v-radio label="Spinning Wheel" value="Spinning Wheel" color="primary" />
        <v-radio label="Box Prize" value="Box Prize" color="primary" />
      </v-radio-group>
      <div class="red--text">
        <v-icon small class="mr-2" color="red">info</v-icon>เมื่อ campaign ถูก publish
        แล้วจะไม่สามารถเปลี่ยนเกมส์ได้ !
      </div>

      <div class="title mt-4">Template</div>
      <v-divider class="my-3" />

      <v-layout wrap>
        <v-flex xs12 sm6 class="pa-1">
          <div class="caption mb-2">Cover</div>

          <uploadfile v-model="input.cover" data-vv-as="Cover" :data-vv-name="'cover'" />
          <div class="caption">ขนาดรูป 662px x 376px</div>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <div class="caption mb-2">Banner</div>

          <uploadfile v-model="input.banner" data-vv-as="Banner" :data-vv-name="'banner'" />
          <div class="caption">ขนาดรูป 500px x 281px</div>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <div class="caption mb-2">Background</div>

          <uploadfile
            v-model="input.background"
            data-vv-as="Generic Image"
            :data-vv-name="'generic_manage_' + '_image'"
          />
          <div class="caption">ขนาดรูป 600px x 1299px</div>
        </v-flex>
      </v-layout>

      <div class="text-xs-center">
        <v-btn outline color="grey" @click="$emit('handleCancel')">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn color="primary" @click="handleSubmit()">
          {{ $t('Next') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
import GameSettingTab from './GameSettingTab'
import GameSettingTitle from './GameSettingTitle'

import { VueEditor } from 'vue2-editor'
export default {
  name: 'GeneralComponent',
  components: {
    uploadfile,
    GameSettingTab,
    GameSettingTitle,
    VueEditor
  },
  inject: ['$validator'],
  props: ['value', 'view'],
  data() {
    return {
      input: null,
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike', 'link'], // toggled buttons
        ['blockquote', 'code-block'],

        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ direction: 'rtl' }], // text direction

        [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }]
      ]
    }
  },
  mounted() {
    if (this.value) {
      this.input = this.value
    }
  },
  methods: {
    async handleSaveDraft() {
      this.$emit('handleSaveDraft')
    },
    async handleChangeView(view) {
      const vm = this
      vm.handleSubmit(() => {
        vm.$emit('handleSubmit', { view: view, data: vm.input })
      })
    },
    async handleSubmit(callback) {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      if (callback) {
        callback()
      } else {
        this.$emit('handleSubmit', { step: 2, data: this.input })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/General.vue